var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.3 122.3",
    style: {
      enableBackground: "new 0 0 122.3 122.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#3B2E85;}\n\t.st2{fill:#3B2E85;}\n\t.st3{fill:#60E4FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 122.7,
    height: 122.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 51.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -25.3751 61.2067)",
    className: "st1",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 51.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -38.4603 30.05)",
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 51.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.4195 92.6898)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.2499 39.0947)",
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 73.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.5867 52.1541)",
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3,
    y: 8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 18.306 79.2782)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4,
    y: 29.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.519 70.1551)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 73.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -34.5743 83.5248)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.7,
    y: 95.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -43.6009 105.3092)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 7.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.2212 17.3067)",
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 95.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.4576 42.9112)",
    className: "st3",
    width: 19.1,
    height: 19.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.020b114b2de366d8476cf8ad42d991ac.svg";
export { ForwardRef as ReactComponent };